<template>
  <div class="body">
    <div class="background">
      <img :src="imgSrc" width="100%" height="100%" alt=""/>
    </div>
    <div class="front">
      <img class="title_img" src="@/assets/img/title.png"/>
      <div class="login_div">
        <div class="input_write">
          <img class="icon_admin" src="@/assets/img/icon_yh.png"/>
          <input type="text" v-model="userName" placeholder="请输入用户名">
        </div>
        <div class="input_write" style="margin-top: .5rem">
          <img class="icon_admin" src="@/assets/img/icon_mm.png"/>
          <input type="text" v-model="passWord" placeholder="请输入密码">
        </div>
        <div class="remember" style="margin-top: .5rem;">
          <img class="icon_r" :src="rememberMeFlag ? require('../assets/img/jx_choose.png'): require('../assets/img/jx.png')" @click="rememberMe"/>
          <div class="remember_me" @click="rememberMe">记住我</div>
        </div>
        <div class="button" style="margin-top: 1.3rem" @click="login">
          登录
        </div>
      </div>

    </div>

  </div>
</template>
<script>
  import {submitForm} from '../api/login.js';

  export default {
    name: "pc_login",
    data() {
      return {
        imgSrc: require('../assets/img/bg_1png.png'),
        rememberMeFlag:false,
        userName : "",
        passWord : "",
        userToken : ""
      }
    },
    created() {
    },
    methods:{
      rememberMe(){
        this.rememberMeFlag = ! this.rememberMeFlag;
      },
      login(){
        let _this = this;
        var name = this.userName
        var pass = this.passWord
        var data = {}
        if(name.trim() == ""){
          alert("请输入用户名")
          return;
        }else {
          data.userName = name
        }
        if(pass.trim() == ""){
          alert("请输入密码")
          return;
        }else {
          data.passWord = pass
        }
        if(name.trim() != "" && pass.trim() != ""){
          submitForm(data).then((res) =>{
            res.message
            console.info("res : " + JSON.stringify(res))
            if(res.code == 200){
              //判断是否记住密码
              if(this.rememberMeFlag){
                //点击了选中按钮
                localStorage.setItem("rememberMeFlag",0);
              }
              localStorage.setItem("Authorization",res.data.token);
              // this.setLocalStorage('Authorization', res.data.token);
              this.$router.push({
                path: '/pc_dp'
              })
            }else {
              alert(res.message)
            }
          })
        }
      },
      setLocalStorage(key,value){
        var curTime = new Date().getTime();
        localStorage.setItem(key,JSON.stringify({data:value,time:curTime}));
      },
      getLocalStorage(key,exp){
        var data = localStorage.getItem(key);
        if(data){
          var dataObj = JSON.parse(data);
          if (new Date().getTime() - dataObj.time>exp) {
            console.log('已过期');
            localStorage.removeItem(key);
          }else{
            console.log('未过期');
            return JSON.parse(dataObj.data)
          }
        }
        return null;
      }
    }
  }
</script>

<style scoped>
  /*.body {
    width: 100%;
    background: url("../assets/img/bg.png") no-repeat;
    background-size: 100% 100%;
  }
*/
  .background {
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
  }

  .front {
    z-index: 1;
    position: absolute;
  }

  .title_img {
    width: 100%;
  }

  .login_div {
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  }

  .input_write {
    width: 6.3rem;
    height: 1.1rem;
    border-radius: 3rem;
    background-color: #677081;
  }

  .icon_admin {
    width: .34rem;
    height: .34rem;
    margin-top: .38rem;
    margin-left: .4rem;
  }

  input {
    font-size: .3rem;
    font-family: "SourceHanSansCN";
    color: rgba(255, 255, 255, 0.8);
    line-height: .34rem;
    background-color: #677081;
    color: #ffffff;
    margin-top: .38rem;
  }

  input::-webkit-input-placeholder {
    color: #ffffff;
  }
  .remember {
    margin-left: -4rem;
  }
  .icon_r {
    width: .3rem;
    height: .3rem;
    display: inline-block
  }
  .remember_me {
    font-size: .26rem;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
    line-height: .34rem;
    display: inline-block
  }
  .button {
    width: 6.3rem;
    height: 1.1rem;
    border-radius: 3rem;
    background-color: #358fff;
    font-size: .36rem;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
    line-height: 1.1rem;
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/pc_login.vue